import { createAcpResource } from 'syft-acp-core/api/resource'

export const workers = createAcpResource('workers', {
  uri: [`/admin/workers`, 'POST'],
  paginated: true,
})
